<template>
  <iCallToast
    title="Your video is paused"
    icon="ic:outline-videocam-off"
    tone="warning"
    dismissible
    dismiss-test-id="camera-paused-dismiss"
    data-test="camera-paused-notice"
    @dismiss="$emit('dismiss')"
  >
    Your connection is weak, so we paused your camera to keep your voice clear. It comes back on by itself.
    <template #actions>
      <iCallToastAction data-test="camera-paused-resume" @click="$emit('turn-camera-on')">
        Turn camera on anyway
      </iCallToastAction>
    </template>
  </iCallToast>
</template>

<script>
export default {
  name: "CameraPausedNotice",
  emits: ["turn-camera-on", "dismiss"],
};
</script>
